import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from "react";
export const DateRangePickerContext = createContext({
    focusStart: () => { },
    focusEnd: () => { },
    startLabelId: "",
    endLabelId: "",
    selectingDescriptionId: ""
});
export const useDateRangePickerContext = () => useContext(DateRangePickerContext);
export const DateRangePickerProvider = ({ setFocusedField, children, startDate, endDate, startLabelId, endLabelId, selectingDescriptionId }) => {
    const contextValue = useMemo(() => {
        const focusStart = () => {
            if (!startDate) {
                return;
            }
            setFocusedField("start");
        };
        const focusEnd = () => {
            if (!endDate) {
                return;
            }
            setFocusedField("end");
        };
        return { focusStart, focusEnd, startLabelId, endLabelId, selectingDescriptionId };
    }, [startLabelId, endLabelId, startDate, endDate, setFocusedField, selectingDescriptionId]);
    return _jsx(DateRangePickerContext.Provider, { value: contextValue, children: children });
};
